/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from "styled-components"
import { formatDate } from "utils/formatDate"
import Heading, { HeadingProps } from "components/Typography/Heading"
import BodyText from "components/Typography/BodyText"
import { FaCircle } from "react-icons/fa"
import UpdateInvoiceButton from "pages/invoice/components/UpdateInvoiceButton"

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;

  svg {
    font-size: 10px;
  }
`

const ActionButtons = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 80px;
`

const ErrorText = styled.span`
  font-size: 14px;
  line-height: 17px;
  color: ${(props) => props.theme.palette.error};
  font-weight: bold;
`

export enum InvoiceStatus {
  SUCCESS = "success",
  UNSUCCESSFUL = "unsuccessful",
  PENDING = "pending"
}

export enum InvoiceStatusLabel {
  "success" = "Paga",
  "unsuccessful" = "Pagamento recusado",
  "pending" = "Pendente"
}

const invoiceStatusColors: Record<InvoiceStatus, HeadingProps["color"]> = {
  [InvoiceStatus.UNSUCCESSFUL]: "error",
  [InvoiceStatus.SUCCESS]: "success",
  [InvoiceStatus.PENDING]: "informative"
}

export const statusLabels = [
  {
    value: InvoiceStatus.SUCCESS,
    label: InvoiceStatusLabel.success
  },
  {
    value: InvoiceStatus.UNSUCCESSFUL,
    label: InvoiceStatusLabel.unsuccessful
  },
  {
    value: InvoiceStatus.PENDING,
    label: InvoiceStatusLabel.pending
  }
]

export const statusLabelsFilters = [
  {
    value: "",
    label: "Todos"
  },
  ...statusLabels
]

export const columns = [
  {
    Header: " ",
    columns: [
      {
        Header: () => <Heading variant="h6">Produto</Heading>,
        accessor: "product",
        Cell: (value: any) => {
          if (value.cell.row.original.productName) {
            return (
              <BodyText size="medium" color="gray-dark">
                {value.cell.row.original.productName}
              </BodyText>
            )
          }

          return <ErrorText>ERRO</ErrorText>
        }
      },
      {
        Header: () => <Heading variant="h6">Cnpj</Heading>,
        accessor: "cnpj",
        Cell: (value: any) => {
          if (value.cell.row.original.cnpj) {
            return (
              <BodyText size="medium" color="gray-dark">
                {value.cell.row.original.cnpj}
              </BodyText>
            )
          }

          return <ErrorText>ERRO</ErrorText>
        }
      },
      {
        Header: () => <Heading variant="h6">Data</Heading>,
        accessor: "createdAt",
        Cell: (value: any) => {
          return (
            <BodyText size="medium" color="gray-dark">
              {value.cell.row.original.createdAt ? formatDate(value.cell.row.original.createdAt) : "-"}
            </BodyText>
          )
        }
      },
      {
        Header: () => <Heading variant="h6">Status</Heading>,
        accessor: "status",
        Cell: (value: any) => {
          return (
            <Heading variant="h6" color={invoiceStatusColors[value.cell.row.original.status]}>
              <StatusContainer>
                <FaCircle />
                {InvoiceStatusLabel[value.cell.row.original.status]}
              </StatusContainer>
            </Heading>
          )
        }
      },
      {
        id: "action",
        Header: () => <Heading variant="h6">Ações</Heading>,
        Cell: (value: any) => (
          <ActionButtons>
            <UpdateInvoiceButton invoice={value.cell.row.original} />
          </ActionButtons>
        )
      }
    ]
  }
]
